const auth = {
  email: 'אימייל',
  password: 'סיסמה',
  welcomeMessage: 'היכנס לחשבונך',

  validations: {
    email: {
      required: 'אימייל נדרש',
      email: 'כתובת אימייל לא חוקית',
      emailReceived: 'כתובת האימייל שקיבלת מהמנה',
    },
    password: {
      required: 'סיסמה נדרשת',
      password: 'סיסמה לא תקינה',
    },
    otp: {
      required: 'נדרש קוד בן 6 ספרות.',
      invalid: 'הקוד שהזנת אינו תקין.'
    }
  },
  resetPassword: {
    email: 'אימייל חסר',
    resetToken: 'אסימון האיפוס אינו תקין',
  },
  loginBtn: 'התחברות',
  toast: {
    authFailed: 'אימייל או סיסמה אינם תקינים',
    unexpectedError: 'אירעה שגיאה בלתי צפויה',
    codeInvalid: 'האימות נכשל. אנא ודא שהזנת את הקוד בן 6 הספרות הנכון או בקש קוד חדש.',
    securityUpdate: 'מדיניות האבטחה עודכנה. אנו מתנצלים על כל אי נוחות.',
  },

  toastBlockRequest: {
    body: 'נחסמת זמנית עקב מספר רב של ניסיונות כושלים. אנא נסה שוב מאוחר יותר',
  },

  /** 2FA related translations below */
  twoFactorAuthSelectMessage: 'בחר שיטת אימות',
  twoFactorAuthVerifyMessage: 'אמת את המכשיר הזה',
  twoFactorAuthVerifyLabel: 'אנא הזן את הקוד בן 6 הספרות ששלחנו לך.',
  sendVerificationCodeBtn: 'שלח קוד אימות',
  phoneMethodLabel: 'SMS',
  verifyBtn: 'שמור',
  resendVerificationCodeBtn: 'שלח קוד מחדש',
  resendVerificationCodeLbl: 'שלח קוד מחדש בעוד {{seconds}} שניות..',
};

export default auth;
